/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import {
    TranslateAdd,
    TranslateDelete,
    TranslateFilterModel,
    TranslationWorkplace,
} from 'models/translateWorkplace';

const axiosSetting: any = {
    responseType: 'arraybuffer',
    params: {},
    headers: {
        'Content-Disposition': 'attachment;filename=report.xls',
    },
};

export const getTranslations = async (axios: AxiosInstance, params: TranslateFilterModel) => {
    const { data } = await axios.get('/translator', { params });
    return data;
};

export const uploadTranslations = async (axios: AxiosInstance, item: TranslateAdd) => {
    return await axios.post('/translator/upload', item);
};

export const sendNotify = async (axios: AxiosInstance) => {
    return await axios.post('/translator/sendNotify');
};

export const addOrChangeTranslationItem = async (axios: AxiosInstance, item: TranslateAdd) => {
    return await axios.post('/translator/', item);
};

export const getTranslationsExcel = async (
    axios: AxiosInstance,
    params: TranslateFilterModel,
    culture?: string
) => {
    axiosSetting.params = { ...params, culture };
    const { data } = await axios.get<Blob>('/translator/excel', axiosSetting);
    return data;
};

export const getTranslationItem = async (axios: AxiosInstance, filter: TranslationWorkplace) => {
    const data = await axios.get<TranslationWorkplace>(
        `/translator/getTranslationItem?brandCode=${filter.brandCode}&type=${filter.type}&name=${filter.name}`
    );
    return data.data;
};

export const getTranslateTypes = async (axios: AxiosInstance) => {
    const { data } = await axios.get<string[]>('/translator/getTypes');
    return data;
};

export const deleteTranslatorItem = async (axios: AxiosInstance, item: TranslateDelete) => {
    return await axios.delete(`/translator`, {
        params: { ...item },
    });
};
